<div class="flex flex-row gap-[0.75rem] items-center flex-wrap">
  @let date = soundSignalDate();
  @let time = soundSignalTime();

  @if (date && time) {
    <div class="flex flex-row gap-[0.5rem] items-center">
      <div class="text-[0.6875rem] font-[500] leading-[150%] text-(--p-primary-500)" translate="@@shared-sound-signal-start__text"></div>
      <div class="flex items-center rounded-[0.5rem] bg-(--p-neutral-500) px-[0.75rem] py-[0.25rem] text-[0.75rem] font-[500] text-(--p-primary-500)">
        <span>{{ date }}</span>
        <span class="mx-[0.375rem] h-[0.875rem] w-px bg-(--p-primary-100)"></span>
        <span>{{ time }}</span>
      </div>
    </div>
  }

  <div class="flex flex-row gap-[0.5rem] items-center">
    <div class="text-[0.6875rem] font-[500] leading-[150%] text-(--p-primary-500)" translate="@@shared-sound-signal_label"></div>
    <div class="flex flex-row gap-[0.375rem] items-center p-[0.375rem] rounded-[0.25rem] bg-(--p-neutral-500)">
      <gc-ld-logger-noise-sound-signal-load
        styleClass="!gap-[0.25rem]"
        [soundSignalId]="soundSignalId()"
        [soundSignalUrl]="soundSignalUrl()"
        [hideImg]="!scrRes.isScreenSmUp()"
        [showDownloadAlways]="true">
      </gc-ld-logger-noise-sound-signal-load>
    </div>
  </div>
</div>
